import * as React from 'react';

import { FiltersTabsContainer } from '../../containers/FiltersTabsContainer';
import { FiltersContainer } from '../../containers/FiltersContainer';
import * as styles from './Hero.css';

export interface IHeroProps {
  title: string;
}

export class Hero extends React.Component<IHeroProps> {
  public render() {
    const { title } = this.props;

    return (
      <div className={styles['wrapper']}>
        <div className={styles['container']} data-mark="Hero">
          <div className={styles['title']}>{title}</div>
          <FiltersTabsContainer />
          <FiltersContainer />
        </div>
      </div>
    );
  }
}
